import { render } from "./DividerTop.vue?vue&type=template&id=8c62e114"
const script = {}

import "./DividerTop.vue?vue&type=style&index=0&id=8c62e114&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__